import { useState, useEffect } from "react";

//

export function useWindowProperty<T extends keyof Window>(key: T) {
  const [value, setValue] = useState(typeof window !== "undefined" ? window[key] : undefined);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const originalValue = window[key]; // Сохраняем оригинальное значение

    Object.defineProperty(window, key, {
      configurable: true,
      get: () => value,
      set: (newValue) => {
        setValue(newValue);
      },
    });

    return () => {
      Object.defineProperty(window, key, {
        configurable: true,
        value: originalValue,
        writable: true,
      });
    };
  }, [key, value]);

  return value;
}
